import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/contexts/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Onboarding from "@/pages/Onboarding";
import AppShell from "@/components/app/AppShell";
import Discover from "@/pages/app/Discover";
import Matches from "@/pages/app/Matches";
import Chat, { ChatList } from "@/pages/app/Chat";
import Schedule from "@/pages/app/Schedule";
import Community from "@/pages/app/Community";
import SetTestLive from "@/pages/app/SetTestLive";
import Settings from "@/pages/app/Settings";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />

            <Route
              path="/onboarding"
              element={
                <ProtectedRoute>
                  <Onboarding />
                </ProtectedRoute>
              }
            />

            <Route
              path="/app"
              element={
                <ProtectedRoute requireOnboarded>
                  <AppShell />
                </ProtectedRoute>
              }
            >
              <Route index element={<Navigate to="/app/discover" replace />} />
              <Route path="discover" element={<Discover />} />
              <Route path="matches" element={<Matches />} />
              <Route path="chat" element={<ChatList />} />
              <Route path="chat/:matchId" element={<Chat />} />
              <Route path="schedule" element={<Schedule />} />
              <Route path="set-test/:setTestId" element={<SetTestLive />} />
              <Route path="community" element={<Community />} />
              <Route path="settings" element={<Settings />} />
            </Route>

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="bottom-center" />
      </AuthProvider>
    </div>
  );
}

export default App;
